// import React, { useState, createContext } from "react";

const DietData = [    
    {
        title: "Plan Optimal",
        shortTitle: "Optimal",
        testExtraPay: 0.0,
        mealCount: 5,
        prices: [
            {
                option: 1200,
                days: [
                    {
                        dayCount: 1,
                        price: 52
                    },
                    {
                        dayCount: 14,
                        price: 51
                    },
                    {
                        dayCount: 21,
                        price: 50
                    },
                    {
                        dayCount: 28,
                        price: 49
                    },
                ]
            },
            {
                option: 1300,
                days: [
                    {
                        dayCount: 1,
                        price: 53
                    },
                    {
                        dayCount: 14,
                        price: 52
                    },
                    {
                        dayCount: 21,
                        price: 51
                    },
                    {
                        dayCount: 28,
                        price: 50
                    },
                ]
            },
            {
                option: 1400,
                days: [
                    {
                        dayCount: 1,
                        price: 54
                    },
                    {
                        dayCount: 14,
                        price: 53
                    },
                    {
                        dayCount: 21,
                        price: 52
                    },
                    {
                        dayCount: 28,
                        price: 51
                    },
                ]
            },
            {
                option: 1500,
                days: [
                    {
                        dayCount: 1,
                        price: 55
                    },
                    {
                        dayCount: 14,
                        price: 54
                    },
                    {
                        dayCount: 21,
                        price: 53
                    },
                    {
                        dayCount: 28,
                        price: 52
                    },
                ]
            },
            {
                option: 1700,
                days: [
                    {
                        dayCount: 1,
                        price: 56
                    },
                    {
                        dayCount: 14,
                        price: 55
                    },
                    {
                        dayCount: 21,
                        price: 54
                    },
                    {
                        dayCount: 28,
                        price: 53
                    },
                ]
            },
            {
                option: 1800,
                days: [
                    {
                        dayCount: 1,
                        price: 57
                    },
                    {
                        dayCount: 14,
                        price: 56
                    },
                    {
                        dayCount: 21,
                        price: 55
                    },
                    {
                        dayCount: 28,
                        price: 54
                    },
                ]
            },
            {
                option: 2000,
                days: [
                    {
                        dayCount: 7,
                        price: 59
                    },
                    {
                        dayCount: 14,
                        price: 58
                    },
                    {
                        dayCount: 21,
                        price: 57
                    },
                    {
                        dayCount: 28,
                        price: 56
                    },
                ]
            },
            {
                option: 2300,
                days: [
                    {
                        dayCount: 7,
                        price: 62
                    },
                    {
                        dayCount: 14,
                        price: 61
                    },
                    {
                        dayCount: 21,
                        price: 60
                    },
                    {
                        dayCount: 28,
                        price: 59
                    },
                ]
            }
        ],
    },

    {
        title: "Plan Wege",
        shortTitle: "Wege",
        testExtraPay: 0.0,
        mealCount: 5,
        prices: [
            {
                option: 1200,
                days: [
                    {
                        dayCount: 1,
                        price: 52
                    },
                    {
                        dayCount: 14,
                        price: 51
                    },
                    {
                        dayCount: 21,
                        price: 50
                    },
                    {
                        dayCount: 28,
                        price: 49
                    },
                ]
            },
            {
                option: 1300,
                days: [
                    {
                        dayCount: 1,
                        price: 53
                    },
                    {
                        dayCount: 14,
                        price: 52
                    },
                    {
                        dayCount: 21,
                        price: 51
                    },
                    {
                        dayCount: 28,
                        price: 50
                    },
                ]
            },
            {
                option: 1400,
                days: [
                    {
                        dayCount: 1,
                        price: 54
                    },
                    {
                        dayCount: 14,
                        price: 53
                    },
                    {
                        dayCount: 21,
                        price: 52
                    },
                    {
                        dayCount: 28,
                        price: 51
                    },
                ]
            },
            {
                option: 1500,
                days: [
                    {
                        dayCount: 1,
                        price: 55
                    },
                    {
                        dayCount: 14,
                        price: 54
                    },
                    {
                        dayCount: 21,
                        price: 53
                    },
                    {
                        dayCount: 28,
                        price: 52
                    },
                ]
            },
            {
                option: 1700,
                days: [
                    {
                        dayCount: 1,
                        price: 56
                    },
                    {
                        dayCount: 14,
                        price: 55
                    },
                    {
                        dayCount: 21,
                        price: 54
                    },
                    {
                        dayCount: 28,
                        price: 53
                    },
                ]
            },
            {
                option: 1800,
                days: [
                    {
                        dayCount: 1,
                        price: 57
                    },
                    {
                        dayCount: 14,
                        price: 56
                    },
                    {
                        dayCount: 21,
                        price: 55
                    },
                    {
                        dayCount: 28,
                        price: 54
                    },
                ]
            },
            {
                option: 2000,
                days: [
                    {
                        dayCount: 7,
                        price: 59
                    },
                    {
                        dayCount: 14,
                        price: 58
                    },
                    {
                        dayCount: 21,
                        price: 57
                    },
                    {
                        dayCount: 28,
                        price: 56
                    },
                ]
            },
            {
                option: 2300,
                days: [
                    {
                        dayCount: 7,
                        price: 62
                    },
                    {
                        dayCount: 14,
                        price: 61
                    },
                    {
                        dayCount: 21,
                        price: 60
                    },
                    {
                        dayCount: 28,
                        price: 59
                    },
                ]
            }
        ],
    },

    {
        title: "Plan IG",
        shortTitle: "IG",
        testExtraPay: 0.0,
        mealCount: 5,
        prices: [
            {
                option: 1200,
                days: [
                    {
                        dayCount: 1,
                        price: 52
                    },
                    {
                        dayCount: 14,
                        price: 51
                    },
                    {
                        dayCount: 21,
                        price: 50
                    },
                    {
                        dayCount: 28,
                        price: 49
                    },
                ]
            },
            {
                option: 1300,
                days: [
                    {
                        dayCount: 1,
                        price: 53
                    },
                    {
                        dayCount: 14,
                        price: 52
                    },
                    {
                        dayCount: 21,
                        price: 51
                    },
                    {
                        dayCount: 28,
                        price: 50
                    },
                ]
            },
            {
                option: 1400,
                days: [
                    {
                        dayCount: 1,
                        price: 54
                    },
                    {
                        dayCount: 14,
                        price: 53
                    },
                    {
                        dayCount: 21,
                        price: 52
                    },
                    {
                        dayCount: 28,
                        price: 51
                    },
                ]
            },
            {
                option: 1500,
                days: [
                    {
                        dayCount: 1,
                        price: 55
                    },
                    {
                        dayCount: 14,
                        price: 54
                    },
                    {
                        dayCount: 21,
                        price: 53
                    },
                    {
                        dayCount: 28,
                        price: 52
                    },
                ]
            },
            {
                option: 1700,
                days: [
                    {
                        dayCount: 1,
                        price: 56
                    },
                    {
                        dayCount: 14,
                        price: 55
                    },
                    {
                        dayCount: 21,
                        price: 54
                    },
                    {
                        dayCount: 28,
                        price: 53
                    },
                ]
            },
            {
                option: 1800,
                days: [
                    {
                        dayCount: 1,
                        price: 57
                    },
                    {
                        dayCount: 14,
                        price: 56
                    },
                    {
                        dayCount: 21,
                        price: 55
                    },
                    {
                        dayCount: 28,
                        price: 54
                    },
                ]
            },
            {
                option: 2000,
                days: [
                    {
                        dayCount: 7,
                        price: 59
                    },
                    {
                        dayCount: 14,
                        price: 58
                    },
                    {
                        dayCount: 21,
                        price: 57
                    },
                    {
                        dayCount: 28,
                        price: 56
                    },
                ]
            },
            {
                option: 2300,
                days: [
                    {
                        dayCount: 7,
                        price: 62
                    },
                    {
                        dayCount: 14,
                        price: 61
                    },
                    {
                        dayCount: 21,
                        price: 60
                    },
                    {
                        dayCount: 28,
                        price: 59
                    },
                ]
            }
        ],
    },

    {
        title: "Dieta Bez Glutenu",
        shortTitle: "Bez Glutenu",
        testExtraPay: 3.0,
        mealCount: 5,
        prices: [
            {
                option: 1200,
                days: [
                    {
                        dayCount: 1,
                        price: 55
                    },
                    {
                        dayCount: 14,
                        price: 54
                    },
                    {
                        dayCount: 21,
                        price: 53
                    },
                    {
                        dayCount: 28,
                        price: 52
                    },
                ]
            },
            {
                option: 1300,
                days: [
                    {
                        dayCount: 1,
                        price: 56
                    },
                    {
                        dayCount: 14,
                        price: 55
                    },
                    {
                        dayCount: 21,
                        price: 54
                    },
                    {
                        dayCount: 28,
                        price: 53
                    },
                ]
            },
            {
                option: 1400,
                days: [
                    {
                        dayCount: 1,
                        price: 57
                    },
                    {
                        dayCount: 14,
                        price: 56
                    },
                    {
                        dayCount: 21,
                        price: 55
                    },
                    {
                        dayCount: 28,
                        price: 54
                    },
                ]
            },
            {
                option: 1500,
                days: [
                    {
                        dayCount: 1,
                        price: 58
                    },
                    {
                        dayCount: 14,
                        price: 57
                    },
                    {
                        dayCount: 21,
                        price: 56
                    },
                    {
                        dayCount: 28,
                        price: 55
                    },
                ]
            },
            {
                option: 1700,
                days: [
                    {
                        dayCount: 7,
                        price: 59
                    },
                    {
                        dayCount: 14,
                        price: 58
                    },
                    {
                        dayCount: 21,
                        price: 57
                    },
                    {
                        dayCount: 28,
                        price: 56
                    },
                ]
            },
            {
                option: 1800,
                days: [
                    {
                        dayCount: 7,
                        price: 60
                    },
                    {
                        dayCount: 14,
                        price: 59
                    },
                    {
                        dayCount: 21,
                        price: 58
                    },
                    {
                        dayCount: 28,
                        price: 57
                    },
                ]
            },
            {
                option: 2000,
                days: [
                    {
                        dayCount: 7,
                        price: 62
                    },
                    {
                        dayCount: 14,
                        price: 61
                    },
                    {
                        dayCount: 21,
                        price: 60
                    },
                    {
                        dayCount: 28,
                        price: 59
                    },
                ]
            },
            {
                option: 2300,
                days: [
                    {
                        dayCount: 7,
                        price: 65
                    },
                    {
                        dayCount: 14,
                        price: 64
                    },
                    {
                        dayCount: 21,
                        price: 63
                    },
                    {
                        dayCount: 28,
                        price: 62
                    },
                ]
            },
            {
                option: 2500,
                days: [
                    {
                        dayCount: 7,
                        price: 67
                    },
                    {
                        dayCount: 14,
                        price: 66
                    },
                    {
                        dayCount: 21,
                        price: 65
                    },
                    {
                        dayCount: 28,
                        price: 64
                    },
                ]
            },
            {
                option: 3000,
                days: [
                    {
                        dayCount: 7,
                        price: 72
                    },
                    {
                        dayCount: 14,
                        price: 71
                    },
                    {
                        dayCount: 21,
                        price: 70
                    },
                    {
                        dayCount: 28,
                        price: 69
                    },
                ]
            }
        ],
    },



    {
        title: "Dieta Bez Laktozy",
        shortTitle: "Bez Laktozy",
        testExtraPay: 3.0,
        mealCount: 5,
        prices: [
            {
                option: 1200,
                days: [
                    {
                        dayCount: 1,
                        price: 55
                    },
                    {
                        dayCount: 14,
                        price: 54
                    },
                    {
                        dayCount: 21,
                        price: 53
                    },
                    {
                        dayCount: 28,
                        price: 52
                    },
                ]
            },
            {
                option: 1300,
                days: [
                    {
                        dayCount: 1,
                        price: 56
                    },
                    {
                        dayCount: 14,
                        price: 55
                    },
                    {
                        dayCount: 21,
                        price: 54
                    },
                    {
                        dayCount: 28,
                        price: 53
                    },
                ]
            },
            {
                option: 1400,
                days: [
                    {
                        dayCount: 1,
                        price: 57
                    },
                    {
                        dayCount: 14,
                        price: 56
                    },
                    {
                        dayCount: 21,
                        price: 55
                    },
                    {
                        dayCount: 28,
                        price: 54
                    },
                ]
            },
            {
                option: 1500,
                days: [
                    {
                        dayCount: 1,
                        price: 58
                    },
                    {
                        dayCount: 14,
                        price: 57
                    },
                    {
                        dayCount: 21,
                        price: 56
                    },
                    {
                        dayCount: 28,
                        price: 55
                    },
                ]
            },
            {
                option: 1700,
                days: [
                    {
                        dayCount: 7,
                        price: 59
                    },
                    {
                        dayCount: 14,
                        price: 58
                    },
                    {
                        dayCount: 21,
                        price: 57
                    },
                    {
                        dayCount: 28,
                        price: 56
                    },
                ]
            },
            {
                option: 1800,
                days: [
                    {
                        dayCount: 7,
                        price: 60
                    },
                    {
                        dayCount: 14,
                        price: 59
                    },
                    {
                        dayCount: 21,
                        price: 58
                    },
                    {
                        dayCount: 28,
                        price: 57
                    },
                ]
            },
            {
                option: 2000,
                days: [
                    {
                        dayCount: 7,
                        price: 62
                    },
                    {
                        dayCount: 14,
                        price: 61
                    },
                    {
                        dayCount: 21,
                        price: 60
                    },
                    {
                        dayCount: 28,
                        price: 59
                    },
                ]
            },
            {
                option: 2300,
                days: [
                    {
                        dayCount: 7,
                        price: 65
                    },
                    {
                        dayCount: 14,
                        price: 64
                    },
                    {
                        dayCount: 21,
                        price: 63
                    },
                    {
                        dayCount: 28,
                        price: 62
                    },
                ]
            },
            {
                option: 2500,
                days: [
                    {
                        dayCount: 7,
                        price: 67
                    },
                    {
                        dayCount: 14,
                        price: 66
                    },
                    {
                        dayCount: 21,
                        price: 65
                    },
                    {
                        dayCount: 28,
                        price: 64
                    },
                ]
            },
            {
                option: 3000,
                days: [
                    {
                        dayCount: 7,
                        price: 72
                    },
                    {
                        dayCount: 14,
                        price: 71
                    },
                    {
                        dayCount: 21,
                        price: 70
                    },
                    {
                        dayCount: 28,
                        price: 69
                    },
                ]
            }
        ],
    },

    {
        title: "Dieta Bez Laktozy i Glutenu",
        shortTitle: "Bez Laktozy i Glutenu",
        testExtraPay: 6.0,
        mealCount: 5,
        prices: [
            {
                option: 1200,
                days: [
                    {
                        dayCount: 1,
                        price: 58
                    },
                    {
                        dayCount: 14,
                        price: 57
                    },
                    {
                        dayCount: 21,
                        price: 56
                    },
                    {
                        dayCount: 28,
                        price: 55
                    },
                ]
            },
            {
                option: 1300,
                days: [
                    {
                        dayCount: 1,
                        price: 59
                    },
                    {
                        dayCount: 14,
                        price: 58
                    },
                    {
                        dayCount: 21,
                        price: 57
                    },
                    {
                        dayCount: 28,
                        price: 56
                    },
                ]
            },
            {
                option: 1400,
                days: [
                    {
                        dayCount: 1,
                        price: 60
                    },
                    {
                        dayCount: 14,
                        price: 59
                    },
                    {
                        dayCount: 21,
                        price: 58
                    },
                    {
                        dayCount: 28,
                        price: 57
                    },
                ]
            },
            {
                option: 1500,
                days: [
                    {
                        dayCount: 1,
                        price: 61
                    },
                    {
                        dayCount: 14,
                        price: 60
                    },
                    {
                        dayCount: 21,
                        price: 59
                    },
                    {
                        dayCount: 28,
                        price: 58
                    },
                ]
            },
            {
                option: 1700,
                days: [
                    {
                        dayCount: 7,
                        price: 62
                    },
                    {
                        dayCount: 14,
                        price: 61
                    },
                    {
                        dayCount: 21,
                        price: 60
                    },
                    {
                        dayCount: 28,
                        price: 59
                    },
                ]
            },
            {
                option: 1800,
                days: [
                    {
                        dayCount: 7,
                        price: 63
                    },
                    {
                        dayCount: 14,
                        price: 62
                    },
                    {
                        dayCount: 21,
                        price: 61
                    },
                    {
                        dayCount: 28,
                        price: 60
                    },
                ]
            },
            {
                option: 2000,
                days: [
                    {
                        dayCount: 7,
                        price: 65
                    },
                    {
                        dayCount: 14,
                        price: 64
                    },
                    {
                        dayCount: 21,
                        price: 63
                    },
                    {
                        dayCount: 28,
                        price: 62
                    },
                ]
            },
            {
                option: 2300,
                days: [
                    {
                        dayCount: 7,
                        price: 68
                    },
                    {
                        dayCount: 14,
                        price: 67
                    },
                    {
                        dayCount: 21,
                        price: 66
                    },
                    {
                        dayCount: 28,
                        price: 65
                    },
                ]
            },
            {
                option: 2500,
                days: [
                    {
                        dayCount: 7,
                        price: 70
                    },
                    {
                        dayCount: 14,
                        price: 69
                    },
                    {
                        dayCount: 21,
                        price: 68
                    },
                    {
                        dayCount: 28,
                        price: 67
                    },
                ]
            },
            {
                option: 3000,
                days: [
                    {
                        dayCount: 7,
                        price: 75
                    },
                    {
                        dayCount: 14,
                        price: 74
                    },
                    {
                        dayCount: 21,
                        price: 73
                    },
                    {
                        dayCount: 28,
                        price: 72
                    },
                ]
            }
        ],
    },

    
    
    {
        title: "Plan Sport",
        shortTitle: "Sport",
        testExtraPay: 0.0,
        mealCount: 5,
        prices: [
            {
                option: 2500,
                days: [
                    {
                        dayCount: 1,
                        price: 64
                    },
                    {
                        dayCount: 14,
                        price: 63
                    },
                    {
                        dayCount: 21,
                        price: 62
                    },
                    {
                        dayCount: 28,
                        price: 61
                    },
                ]
            },
            {
                option: 3000,
                days: [
                    {
                        dayCount: 1,
                        price: 69
                    },
                    {
                        dayCount: 14,
                        price: 68
                    },
                    {
                        dayCount: 21,
                        price: 67
                    },
                    {
                        dayCount: 28,
                        price: 66
                    },
                ]
            },
            {
                option: 3500,
                days: [
                    {
                        dayCount: 1,
                        price: 74
                    },
                    {
                        dayCount: 14,
                        price: 73
                    },
                    {
                        dayCount: 21,
                        price: 72
                    },
                    {
                        dayCount: 28,
                        price: 71
                    },
                ]
            }
        ],
    },

    {
        title: "Low Carb",
        shortTitle: "Low Carb",
        testExtraPay: 0.0,
        mealCount: 5,
        prices: [
            {
                option: 1500,
                days: [
                    {
                        dayCount: 1,
                        price: 60
                    },
                    {
                        dayCount: 14,
                        price: 59
                    },
                    {
                        dayCount: 21,
                        price: 58
                    },
                    {
                        dayCount: 28,
                        price: 57
                    },
                ]
            },
            {
                option: 2000,
                days: [
                    {
                        dayCount: 1,
                        price: 65
                    },
                    {
                        dayCount: 14,
                        price: 64
                    },
                    {
                        dayCount: 21,
                        price: 63
                    },
                    {
                        dayCount: 28,
                        price: 62
                    },
                ]
            },
            {
                option: 2500,
                days: [
                    {
                        dayCount: 1,
                        price: 68
                    },
                    {
                        dayCount: 14,
                        price: 67
                    },
                    {
                        dayCount: 21,
                        price: 66
                    },
                    {
                        dayCount: 28,
                        price: 65
                    },
                ]
            }
        ],
    }
]

export default DietData